'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _defineProperty = _interopDefault(require('@babel/runtime/helpers/defineProperty'));
var React = _interopDefault(require('react'));
var PropTypes = _interopDefault(require('prop-types'));
var styled = _interopDefault(require('styled-components'));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var primary = function primary() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    disabled = _ref.disabled,
    active = _ref.active,
    hover = _ref.hover;
  var base = {};
  if (disabled) {
    return _objectSpread(_objectSpread({}, base), {}, {
      borderColor: '#ccc',
      backgroundColor: '#ccc',
      cursor: 'not-allowed'
    });
  }
  if (active) {
    return _objectSpread(_objectSpread({}, base), {}, {
      backgroundColor: '#286090'
    });
  }
  if (hover) {
    return _objectSpread(_objectSpread({}, base), {}, {
      hover: {
        borderColor: '#286090',
        backgroundColor: '#286090',
        color: '#fff'
      }
    });
  }
  return base;
};
var outline = function outline() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    disabled = _ref2.disabled,
    active = _ref2.active,
    hover = _ref2.hover;
  var base = _objectSpread(_objectSpread({}, primary()), {}, {
    borderStyle: 'solid',
    borderColor: '#2b7cac',
    borderWidth: '1px',
    backgroundColor: 'transparent',
    color: '#2b7cac'
  });
  if (disabled) {
    return _objectSpread(_objectSpread(_objectSpread({}, primary({
      disabled: disabled
    })), base), {}, {
      borderColor: '#ccc',
      color: '#ccc'
    });
  }
  if (active) {
    return _objectSpread(_objectSpread({}, base), {}, {
      borderWidth: '0.25rem'
    });
  }
  if (hover) {
    return _objectSpread(_objectSpread({}, base), {}, {
      hover: {
        borderColor: '#286090',
        backgroundColor: 'transparent',
        color: '#286090'
      }
    });
  }
  return base;
};
var StyledButton = styled.button.withConfig({
  componentId: "asyap2-0"
})(["display:inline-block;position:relative;text-decoration:", ";text-align:", ";width:", ";height:", ";min-width:", ";min-height:", ";margin-top:", ";margin-right:", ";margin-bottom:", ";margin-left:", ";padding-top:", ";padding-right:", ";padding-bottom:", ";padding-left:", ";border-style:", ";border-color:", ";border-width:", ";border-radius:", ";line-height:", ";font-family:", ";font-weight:", ";font-size:", ";background-color:", ";color:", ";cursor:", ";", ";"], function (props) {
  var _props$s;
  return ((_props$s = props.s) === null || _props$s === void 0 ? void 0 : _props$s.textDecoration) || 'none';
}, function (props) {
  var _props$s2;
  return ((_props$s2 = props.s) === null || _props$s2 === void 0 ? void 0 : _props$s2.textAlign) || 'center';
}, function (props) {
  var _props$s3, _props$s4;
  if (props.big) return '100%';
  if ((_props$s3 = props.s) !== null && _props$s3 !== void 0 && _props$s3.width) return (_props$s4 = props.s) === null || _props$s4 === void 0 ? void 0 : _props$s4.width;
  return 'auto';
}, function (props) {
  var _props$s5;
  return ((_props$s5 = props.s) === null || _props$s5 === void 0 ? void 0 : _props$s5.height) || '2.5rem';
}, function (props) {
  var _props$s6;
  return ((_props$s6 = props.s) === null || _props$s6 === void 0 ? void 0 : _props$s6.minWidth) || '6.25rem';
}, function (props) {
  var _props$s7;
  return ((_props$s7 = props.s) === null || _props$s7 === void 0 ? void 0 : _props$s7.minHeight) || '2.5rem';
}, function (props) {
  var _props$s8;
  return ((_props$s8 = props.s) === null || _props$s8 === void 0 ? void 0 : _props$s8.marginTop) || 0;
}, function (props) {
  var _props$s9;
  return ((_props$s9 = props.s) === null || _props$s9 === void 0 ? void 0 : _props$s9.marginRight) || 0;
}, function (props) {
  var _props$s10;
  return ((_props$s10 = props.s) === null || _props$s10 === void 0 ? void 0 : _props$s10.marginBottom) || 0;
}, function (props) {
  var _props$s11;
  return ((_props$s11 = props.s) === null || _props$s11 === void 0 ? void 0 : _props$s11.marginLeft) || 0;
}, function (props) {
  var _props$s12;
  return ((_props$s12 = props.s) === null || _props$s12 === void 0 ? void 0 : _props$s12.paddingTop) || 0;
}, function (props) {
  var _props$s13;
  return ((_props$s13 = props.s) === null || _props$s13 === void 0 ? void 0 : _props$s13.paddingRight) || '0.5rem';
}, function (props) {
  var _props$s14;
  return ((_props$s14 = props.s) === null || _props$s14 === void 0 ? void 0 : _props$s14.paddingBottom) || 0;
}, function (props) {
  var _props$s15;
  return ((_props$s15 = props.s) === null || _props$s15 === void 0 ? void 0 : _props$s15.paddingLeft) || '0.5rem';
}, function (props) {
  var _props$s16;
  return ((_props$s16 = props.s) === null || _props$s16 === void 0 ? void 0 : _props$s16.borderStyle) || 'none';
}, function (props) {
  var _props$s17;
  return ((_props$s17 = props.s) === null || _props$s17 === void 0 ? void 0 : _props$s17.borderColor) || '#2b7cac';
}, function (props) {
  var _props$s18;
  return ((_props$s18 = props.s) === null || _props$s18 === void 0 ? void 0 : _props$s18.borderWidth) || '1px';
}, function (props) {
  var _props$s19;
  return ((_props$s19 = props.s) === null || _props$s19 === void 0 ? void 0 : _props$s19.borderRadius) || '0.125rem';
}, function (props) {
  var _props$s20;
  return ((_props$s20 = props.s) === null || _props$s20 === void 0 ? void 0 : _props$s20.lineHeight) || '1rem';
}, function (props) {
  var _props$s21;
  return ((_props$s21 = props.s) === null || _props$s21 === void 0 ? void 0 : _props$s21.fontFamily) || 'inherit';
}, function (props) {
  var _props$s22;
  return ((_props$s22 = props.s) === null || _props$s22 === void 0 ? void 0 : _props$s22.fontWeight) || 'bold';
}, function (props) {
  var _props$s23;
  return ((_props$s23 = props.s) === null || _props$s23 === void 0 ? void 0 : _props$s23.fontSize) || '0.75rem';
}, function (props) {
  var _props$s24;
  return ((_props$s24 = props.s) === null || _props$s24 === void 0 ? void 0 : _props$s24.backgroundColor) || '#2b7cac';
}, function (props) {
  var _props$s25;
  return ((_props$s25 = props.s) === null || _props$s25 === void 0 ? void 0 : _props$s25.color) || '#fff';
}, function (props) {
  var _props$s26;
  return ((_props$s26 = props.s) === null || _props$s26 === void 0 ? void 0 : _props$s26.cursor) || 'pointer';
}, function (props) {
  var _props$s27, _props$s28, _props$s29, _props$s30;
  return ((_props$s27 = props.s) === null || _props$s27 === void 0 ? void 0 : _props$s27.hover) && "\n    &:hover {\n      border-color: ".concat(((_props$s28 = props.s) === null || _props$s28 === void 0 ? void 0 : _props$s28.hover.borderColor) || '#286090', ";\n      background-color: ").concat(((_props$s29 = props.s) === null || _props$s29 === void 0 ? void 0 : _props$s29.hover.backgroundColor) || '#286090', ";\n      color: ").concat(((_props$s30 = props.s) === null || _props$s30 === void 0 ? void 0 : _props$s30.hover.color) || '#fff', ";\n    }\n  ");
});
var Button = function Button(_ref3) {
  var className = _ref3.className,
    onClick = _ref3.onClick,
    href = _ref3.href,
    target = _ref3.target,
    rel = _ref3.rel,
    s = _ref3.s,
    type = _ref3.type,
    big = _ref3.big,
    disabled = _ref3.disabled,
    children = _ref3.children;
  var isLink = typeof href === 'string';
  var button = /*#__PURE__*/React.createElement(StyledButton, {
    s: s,
    big: big,
    disabled: disabled,
    className: className,
    tabIndex: isLink ? -1 : undefined,
    onClick: isLink ? undefined : onClick,
    type: isLink ? undefined : type
  }, children);
  if (isLink) {
    return /*#__PURE__*/React.createElement("a", {
      href: href,
      target: target,
      rel: target === '_blank' ? "noopener noreferrer".concat(rel ? " ".concat(rel) : '') : rel,
      onClick: onClick
    }, button);
  }
  return button;
};
Button.defaultProps = {
  className: '',
  onClick: function onClick() {
    return undefined;
  },
  href: null,
  target: null,
  rel: null,
  s: {},
  type: 'button',
  big: false,
  disabled: false
};
Button.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  href: PropTypes.string,
  target: PropTypes.oneOf(['_self', '_blank', '_parent', '_top']),
  rel: PropTypes.string,
  s: PropTypes.shape({
    width: PropTypes.string,
    height: PropTypes.string,
    minWidth: PropTypes.string,
    minHeight: PropTypes.string,
    marginTop: PropTypes.string,
    marginRight: PropTypes.string,
    marginBottom: PropTypes.string,
    marginLeft: PropTypes.string,
    borderStyle: PropTypes.string,
    borderColor: PropTypes.string,
    borderWidth: PropTypes.string,
    borderRadius: PropTypes.string,
    lineHeight: PropTypes.string,
    fontFamily: PropTypes.string,
    fontWeight: PropTypes.string,
    fontSize: PropTypes.string,
    backgroundColor: PropTypes.string,
    color: PropTypes.string,
    cursor: PropTypes.string,
    hover: PropTypes.shape({
      borderColor: PropTypes.string,
      backgroundColor: PropTypes.string,
      color: PropTypes.string
    })
  }),
  children: PropTypes.node.isRequired,
  type: PropTypes.string,
  big: PropTypes.bool,
  disabled: PropTypes.bool
};

exports.default = Button;
exports.outline = outline;
exports.primary = primary;
